export default __webpack_public_path__ + "static/media/compare__item-img-2.ef5254c5.svg";